<template>
	<div class="tg-share">
		<HeaderTopView v-bind:num="num" @childFn="parentFn($event)"></HeaderTopView>
		<HeaderView></HeaderView>
		<NavView></NavView>
		<div class="adv">
			<div class="word">
				<div class="top-title">{{$t('tgshare.title')}}</div>
				<h3 class="se-title">{{$t('tgshare.txt')}}</h3>

				<div class="inpbox">
					<input type="text" v-model="title" :placeholder="$t('tgshare.inp')" class="inp" @input="inp">
					<div class="f-r" @click="getFile">
						<div class="find-img">
							<img src="@/assets/images/find.png" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="word">
			<section>
				<div class="content">
					<div class="top-select-box">
						<div class="is-select">
							<div class="se-l">
								<span class="se-name">{{$t('tgshare.selection')}}</span>
								<div class="select-item">
									<div class="item" v-for="(item,index) in select" :key="index">
										<span>{{item}}</span>
										<div class="colose">
											<img src="@/assets/images/x.png" alt @click="deleteItem(index)" />
										</div>
									</div>
								</div>
								<div class="clear" @click="empty">{{$t('tgshare.empty')}}</div>
							</div>
							<div class="num">
								{{$t('tgshare.search')}}
								<span class="r-f">{{file.length}}</span>{{$t('tgshare.strip')}}
							</div>
						</div>

						<div class="type-list" v-for="(item,index) in newData" :key="index">
							<div class="list-name">{{item.name}}：</div>
							<div class="type-item-list">
								<span v-for="(item1,index1) in item.item" :key="index1" class="type-item" :class="{'selected' :index1 == idx && index == idt}"
								 @click="selected(item1,index1,index)">{{item1.type}}</span>
							</div>
						</div>
					</div>

					<!-- 文章内容 -->
					<div class="dv" v-for="(item,index) in file" :key="index">
						<div class="flex_between">
							<div class="flex_start">
								<img src="@/assets/images/pdf.png" alt="" class="wd_img" v-if=" item.docUrl !== null ? item.docUrl.split('.')[1] == 'pdf':''">
								<img src="@/assets/images/txt.png" alt="" class="wd_img" v-if="item.docUrl === null">
								<img src="@/assets/images/word.png" alt="" class="wd_img" v-if=" item.docUrl !== null ? item.docUrl.split('.')[1] === 'doc':''">
								<div class="wd_title" v-html="item.title"></div>
							</div>
							<div class="flex_start">
								<a href="javascript:void(0)" style="margin-right: 10px;" download @click="download(item.docUrl,item.tid)" v-if="item.docUrl === null">
									<el-button type="primary" size="mini">{{$t('tgshare.member')}}<i class="el-icon-bottom el-icon--right"></i></el-button>
								</a>
								<a href="javascript:void(0)" @click="download(item.docUrl,item.tid)" download v-else>
									<el-button size="mini">{{$t('tgshare.ordinary')}}<i class="el-icon-bottom el-icon--right"></i></el-button>
								</a>
							</div>
						</div>
						<div class="wd_txt" v-html="item.description"></div>
						<div class="time flex_start">
							<span>{{$t('tgshare.Views')}}：{{item.browseCount}}</span>
							<span class="l"></span>
							<span>{{$t('tgshare.Download')}}：{{item.dowloadCount?item.dowloadCount:0}}</span>
							<span class="l"></span>
							<span>{{$t('tgshare.Upload')}}：{{item.createTime}}</span>
						</div>
					</div>
				</div>
			</section>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
	import HeaderTopView from "@/components/assembly/HeaderTop.vue"; //头部模块
	import HeaderView from "@/components/assembly/Header.vue"; //头部模块
	import NavView from "@/components/assembly/Nav.vue"; //导航模块
	import Footer from "@/components/assembly/Footer.vue"; //导航模块
	export default {
		components: {
			HeaderTopView,
			NavView,
			Footer,
			HeaderView
		},
		data() {
			return {
				file: [],
				num: "1",
				data: [{
						name: "文档分类",
						item: []
					},
					{
						name: "下载权限",
						item: ["全部", "会员", "免费"]
					}
				],
				select: [],
				allSelect: [],
				newData: [],
				title: '',
				idx: -1,
				idt: -1,
				id: ""
			};
		},
		methods: {
			// 输入框清空
			inp() {
				if (this.title == '') {
					this.getFile()
				}
			},
			getNum() {
				let url = `/open/technology/record/download/count`
				let data = {
					token: sessionStorage.getItem('token'),
					tid: id
				}
				this.$get(url, data).then(res => {
					if (res.code == 0) {
						this.getFile()
					}

				});
			},
			// 下载
			download(urls, id) {
				if (urls == null) {
					let url = `/api/technology/record/download/auth`
					let data = {
						token: sessionStorage.getItem('token'),
						tid: id
					}
					this.$get(url, data).then(res => {
						if (res.code == 0) {
							location.href = this.$img + res.data
						} else {
							this.$message({
								message: this.$t('Tips.nojurisdiction'),
								type: 'warning'
							});
						}
					});
					return false
				}
				location.href = this.$img + urls
				this.getNum()
			},
			// 获取筛选类
			getType() {
				let that = this;
				let url = `/open/technology/get/types?token=${sessionStorage.getItem('token')}`;
				this.$get(url).then(res => {
					if (res.code == 0) {
						that.data[0].item = res.data
						that.data[0].name = this.$t('tgshare.classification')
						that.data[1].name = this.$t('tgshare.jurisdiction')
						that.data[1].item = this.$t('tgshare.tab')
						that.getData()
					}

				});
			},
			// 清空
			empty() {
				this.select = []
				this.idx = -1
				this.idt = -1
			},
			parentFn() {},
			selected(item1, index1, index) {
				if (index == 0) {
					this.id = ''
					this.title = item1.type
				} else {
					this.title = ''
					if (item1.type == '会员') {
						this.id = 1
					} else if (item1.type == '免费') {
						this.id = 0
					} else {
						this.id = ''
					}
				}
				this.idx = index1
				this.idt = index
				this.getFile()
				if (item1.lock) {
					return;
				} else {
					this.select.push(item1.type);
					item1.lock = true;
				}
			},
			deleteItem(index) {
				this.select.splice(index, 1);
			},
			getFile() {
				let that = this;
				let url =
					`/open/technology/list?pageNum=1&pageSize=10&keyWord=${this.title}&downloadGrade=${this.id}`;
				this.$get(url).then(res => {
					if (res.code == 0) {
						that.file = res.data
					}
				});
			},
			getData() {
				let newData = [];
				this.data.forEach(item => {
					let dataList = {};
					let arr = [];
					item.item.forEach(i => {
						let obj = {
							type: "",
							lock: ""
						};
						obj.type = i;
						for (let j = 0; j < this.select.length; j++) {
							if (this.select[j] == i) {
								obj.lock = true;
								break;
							} else {
								obj.lock = false;
							}
						}
						arr.push(obj);
					});
					dataList.name = item.name;
					dataList.item = arr;
					newData.push(dataList);
				});
				this.newData = newData;
			}
		},
		mounted() {
			this.getFile()
			this.getType()
		}
	};
</script>
<style scoped>
	.l {
		width: 1px;
		height: 10px;
		margin: 0 15px;
		background: #CCCCCC;
	}

	.wd_txt {
		padding: 20px 0;
		font-size: 16px;
		color: #666666;
		border-bottom: dashed 1px #ccc;
		text-align: left;
	}

	.time {
		padding: 20px 0;
		font-size: 14px;
		color: #666;
		align-items: center;
	}

	.wd_title {
		font-size: 20px;
		color: #107AD0;
		margin-left: 17px;
	}

	.dv {
		margin-top: 20px;
		width: calc(100% - 60px);
		background: white;
		padding: 30px;
	}

	.wd_img {
		width: 30px;
		height: 30px;
	}

	.adv {
		width: 100%;
		height: 300px;
		background: url("../../assets/images/bg6.png") center center no-repeat;
		background-size: cover;
		padding-top: 77px;
	}

	.top-title {
		font-size: 40px;
		color: #fff;
		text-align: left;
	}

	.se-title {
		font-size: 18px;
		color: #fff;
		text-align: left;
		margin-top: 19px;
	}

	.content {
		margin-bottom: 81px;
	}

	.inpbox {
		height: 43px;
		display: flex;
		justify-content: flex-start;
		margin-top: 28px;
		align-items: center;
	}

	.find-img {
		width: 25px;
		height: 25px;
	}

	.f-r {
		width: 59px;
		height: 43px;
		background: #0090ff;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.inp {
		width: 459px;
		padding: 0;
		margin: 0;
		padding-left: 14px;
		height: 100%;
	}

	img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.content {
		margin-top: 28px;
	}

	.top-select-box {
		background: #fff;
		padding: 0 38px;
	}

	.is-select {
		display: flex;
		justify-content: space-between;
		font-size: 16px;
		padding-top: 21px;
		color: #939393;
		padding-bottom: 10px;
		border-bottom: 1px solid #e2e2e2;
	}

	.se-l {
		display: flex;
		flex: 1;
	}

	.num {
		font-size: 16px;
		color: #333333;
		margin-left:12px;
	}

	.se-name {
		color: #4a4a4a;
		font-size: 16px;
		width: 50px;
	}

	.list-name {
		color: #4a4a4a;
		font-size: 16px;
		margin-right: 30px;
	}

	.r-f {
		color: #ea2323;
	}

	.select-item {
		margin-left: 20px;
		display: flex;
		flex-wrap: wrap;
		flex: 1;
	}

	.item {
		font-size: 16px;
		color: #4a4a4a;
		border: 1px solid #cccccc;
		display: flex;
		align-items: center;
		height: 30px;
		box-sizing: border-box;
		padding: 0 12px 0 9px;
		margin-right: 19px;
		margin-bottom: 10px;
	}

	.colose {
		margin-left: 6px;
	}

	.colose {
		width: 10px;
		height: 10px;
	}

	.clear {
		color: #939393;
		margin-left: 19px;
	}

	.type-list {
		height: 70px;
		border-bottom: 2px dashed #e2e2e2;
		display: flex;
		align-items: center;
	}

	.type-list:last-child {
		border: 0;
	}

	.type-item-list {
		margin-right: 30px;
	}

	.type-item {
		font-size: 16px;
		color: #4a4a4a;
	}

	.type-item {
		margin-right: 55px;
	}

	.selected {
		color: #0090ff;
	}
</style>



// WEBPACK FOOTER //
// src/components/tgShare/TgShare.vue